import { render, staticRenderFns } from "./ItemListModal.vue?vue&type=template&id=18e87442&scoped=true"
import script from "./ItemListModal.vue?vue&type=script&lang=js"
export * from "./ItemListModal.vue?vue&type=script&lang=js"
import style0 from "./ItemListModal.vue?vue&type=style&index=0&id=18e87442&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e87442",
  null
  
)

export default component.exports